import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { fetchAppCategory , patchAppCategory  , setPageSize , clearCache} from "@/slices/accessManager/AccessAppCategorySlice";
import EditableTable from '../../components/EditableTable';
import Loader from '../../components/Loader';
import Modal from "../../components/Modal";
import ChangeLog from "../../components/ChangeLog";
import SimplePagination from "@/components/SimplePagination";
import PanelUserSearch from "@/components/PanelUserSearch";
import PageSizeSelector from "@/components/PageSizeSelector";

const AppCategory = () => {
  const dispatch = useDispatch();
  const { accessAppCategoryList, currentPage, totalPages, status,  search , pageSize  } = useSelector((state) => state.accessAppCategory);
  const [editRowId, setEditRowId] = useState(null);
  const [editedData, setEditedData] = useState({});
  const [searchInput, setSearchInput] = useState(search || "");


    useEffect(() => {
   dispatch(fetchAppCategory({page: 1 , search}));
 }, [dispatch]);

  const headers = accessAppCategoryList?.result?.length > 0 ? Object.keys(accessAppCategoryList.result[0]).filter((key) => key !== 'id') : [];
  const editableFields = ['title','active']; // Define editable fields

  const [currentLog,setCurrentLog] = useState([]);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const openModal = () => setIsModalOpen(true);
  const closeModal = () => setIsModalOpen(false);
  

  const handleLog = (id)=>{
    const logData = accessAppCategoryList?.Change_Log?.filter((f)=>f.id===id)[0]?.oldTrack;
    setCurrentLog(logData)
    openModal()
  }


  const hasData = accessAppCategoryList?.result?.length > 0;

   // ✅ Page size change
    const handlePageSizeChange = (size) => {
      dispatch(setPageSize(size)); // update slice
      dispatch(fetchAppCategory({ page: 1 , search}));
    }; 

   useEffect(() => {
     setSearchInput(search || "");
   }, [search]);

 
  if (status === "loading") {
    return (
      <div className="w-full pt-20 flex justify-center">
        <Loader />
      </div>
    );
  }


  const handleEdit = (rowId) => {
    setEditRowId(rowId);
    const rowData = accessAppCategoryList.result.find((user) => user.id === rowId);
    setEditedData(rowData);
  };

  const handleSave = async () => {
    const { id, ...editableData } = editedData;
    const updatedData = { id, ...editableData };
    const resp = await dispatch(patchAppCategory(updatedData));
    if (!resp.error) {
      setEditRowId(null);
      // dispatch(fetchAppCategory(currentPage));
      await dispatch(clearCache()); // resets cache internally
      await dispatch(fetchAppCategory({ page: 1, search : ""}));
    }
  };

  const handleCancel = () => {
    setEditRowId(null);
    setEditedData({});
  };

  const handleChange = (e, field) => {
    setEditedData((prev) => ({
      ...prev,
      [field]: e.target.value,
    }));
  };


  return (
    <div className="w-full flex items-center flex-col">
      <div className="max-w-full">
         {hasData ? (
        <EditableTable
        headers={headers}
        rows={accessAppCategoryList?.result}
        editRowId={editRowId}
        editedData={editedData}
        handleEdit={handleEdit}
        handleSave={handleSave}
        handleCancel={handleCancel}
        handleChange={handleChange}
        handleLog={handleLog}
        editableFields={editableFields} // Pass editable fields
        />
 ) : (
    <div className="w-full flex flex-col items-center justify-center py-20 text-gray-500">

      {/* Icon */}
      <div className="text-5xl mb-3">🔍</div>

      {/* Message */}
      {searchInput ? (
        <>
          <p className="text-lg font-medium">No results found</p>
          <p className="text-sm mt-1">
            for "<span className="font-semibold">{searchInput}</span>"
          </p>
        </>
      ) : (
        <>
          <p className="text-lg font-medium">No Data Available</p>
          <p className="text-sm mt-1">
            There are no users to display
          </p>
        </>
      )}

    </div>
  )}
    </div>

    
    
  <div className="flex mt-4 items-center justify-between w-11/12">

    {!search && (
    <PageSizeSelector
      pageSize={pageSize}
      setPageSize={handlePageSizeChange}
    />
    )}

    {!search && (
  <SimplePagination
    currentPage={currentPage}
    setCurrentPage={(page) =>
      dispatch(fetchAppCategory({ page , search}))
    }
    totalPages={totalPages}
  />
)}
    </div>

<Modal
        isOpen={isModalOpen}
        onClose={closeModal}
        title="Change Log"
        content={<ChangeLog data={currentLog}/>}
      />
    </div>
  );
};

export default AppCategory;
